<ng-container *ngIf="authReady">
  <ng-container *ngIf="isFullPageRoute(); else appShell">
    <router-outlet></router-outlet>
  </ng-container>

  <ng-template #appShell>
    <div class="main-container" [ngClass]="{ collapsed: !sidebarOpen }">
      <div class="left-container">
        <gains-sidenav (toggleSidebarEvent)="toggleSidebar()"></gains-sidenav>
      </div>
      <div class="right-container">
        <gains-breadcrumb></gains-breadcrumb>
        <router-outlet></router-outlet>
      </div>
    </div>
  </ng-template>
</ng-container>
